var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (this.show)?_c('div',[_c('br'),_c('b-alert',{staticClass:"myAlert center info",attrs:{"show":""}},[_vm._v("\n    "+_vm._s(this.description)+"\n    "),_c('br'),_c('br'),_vm._v("\n    "+_vm._s(this.menuLink)+"\n  ")])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }